/**
 * Formats an ISO date/timestamp as "Jul 29, 2026". Returns the input unchanged
 * when it isn't parseable, and an em dash for a missing value, so callers can
 * render the result directly without guarding first.
 */
export function formatDate(isoDate) {
  if (!isoDate) return '—'
  const d = new Date(isoDate)
  if (isNaN(d.getTime())) return isoDate
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}
